import React, { Component } from 'react'
import Button from '@atlaskit/button'
import { DescriptionList } from '../../../components/index'
import { ReactRenderer } from '@atlaskit/renderer';

class DynamicView extends Component {
  render () {

    let { Issue, editIssue } = this.props    
    let { properties } = Issue.requestType.inputs    
    let issueItems = properties.reduce((result, field) => {       
      result[`${field.title}`] = field.type == 'wiki' || field.jiraFieldName =='description' ?
      <ReactRenderer document={Issue[field.id]} /> : Issue[field.id]
      return result
    }, {})    

    return (
      <div>
        <DescriptionList hideEmpty items={issueItems} />
        <Button type='button' appearance='primary' onClick={editIssue}>Edit</Button>
      </div>
    )
  }
}

export default DynamicView



// WEBPACK FOOTER //
// ./client/src/serviceDesk/request/forms/DynamicView.js